import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";

import { Fieldset, Field, Control, Button, Label } from "rbx";
import { CREATE_NOTE_MUTATION } from "../../graphql/Notes/Notes.graphql";
import { SystemCodeSelect, PoorTextEditor } from "../inputs";

import { ourToast as toast } from "../../utils";

import Section from "../Section";

class AddEmployeeNoteForm extends Component {
  state = {
    NoteTypeRecIdRef: "",
    Note: "",
    TableName: "Employees"
  };

  onChange = evt => {
    this.setState({
      [evt.target.name]: evt.target.value
    });
  };

  render() {
    const { NoteTypeRecIdRef, Note, TableName } = this.state;
    const { onComplete, EmployeeRecIdRef } = this.props;
    return (
      <Mutation
        mutation={CREATE_NOTE_MUTATION}
        refetchQueries={["ALL_NOTES_QUERY"]}
        variables={{
          data: {
            RefRecId: parseInt(EmployeeRecIdRef),
            NoteTypeRecIdRef: parseInt(NoteTypeRecIdRef),
            Note,
            TableName
          }
        }}
      >
        {(createNote, { loading, error }) => (
          <Section title="Add Note">
            <form
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await createNote();
                  onComplete();
                  toast.success("Note added successfully.");
                } catch (err) {
                  toast.error("Error adding Note.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <Field>
                  <Control>
                    <SystemCodeSelect
                      required
                      icon="globe"
                      label="Note Type"
                      lookup={{ Category: "Employee", Code: "EmployeeNote" }}
                      name="NoteTypeRecIdRef"
                      value={NoteTypeRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Note</Label>
                    <PoorTextEditor
                      name="Note"
                      value={Note}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <hr />
                <Field kind="group">
                  <Control>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={onComplete}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

AddEmployeeNoteForm.propTypes = {
  EmployeeRecIdRef: PropTypes.number,
  onComplete: PropTypes.func
};
export default AddEmployeeNoteForm;
